document.querySelectorAll('a[href^="#"]').forEach(a => {
    const menuOpener = document.getElementById('mobile-hamburger');

    a.addEventListener('click', function (e) {
        e.preventDefault();
        const href = this.getAttribute('href');
        const elem = document.querySelector(href)||document.querySelector('a[name='+href.substring(1, href.length)+']');

        window.scroll({
            top: elem.offsetTop - 70,
            left: 0,
            behavior: 'smooth',
        });

        if(menuOpener.classList.contains('is-active')) {
            document.body.dispatchEvent(new Event('click'));
        }
    });
});



// WEBPACK FOOTER //
// ./scripts/autoload/smoothScroll.js